import React from "react";

import { StateCallbacks } from "../../../state";
import { State, TableCellBlock } from "../../../types";
import { Cell } from "./Cell";

type Props = Readonly<{
  blocks: State["blocks"];
  fontInformation: State["fontInformation"];
  isHeader: boolean;
  row: Array<string>;
  onSelectBlock: StateCallbacks["onSelectBlock"];
  selectedCell: string | null;
  setShowReferences: (blockId: string) => void;
}>;

export const Row = ({
  blocks,
  fontInformation,
  isHeader,
  onSelectBlock,
  row,
  selectedCell,
  setShowReferences,
}: Props) => (
  <tr>
    {row.map(cellId => {
      let referencesLink;
      if (blocks[cellId].references.length > 0) {
        referencesLink = (
          <small className="d-block text-right">
            <a
              href="#"
              id={`link-${cellId}`}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                setShowReferences(cellId);
              }}
            >
              Data ({blocks[cellId].references.length})
            </a>
          </small>
        );
      }
      return (
        <Cell
          cell={blocks[cellId] as TableCellBlock}
          fontInformation={fontInformation}
          isHeader={isHeader}
          key={cellId}
          onSelectBlock={onSelectBlock}
          referencesLink={referencesLink}
          selectedCell={selectedCell}
        />
      );
    })}
  </tr>
);
Row.displayName = "Row";
